
























import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
  name: "Selector",
})
export default class Selector extends Vue {
  @Prop({
    type: Boolean,
    default() {
      return;
    },
  })
  required!: boolean;
  @Prop({
    type: Array,
  })
  items!: string[] | object[] ;
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  value!: string;
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  label!: string;
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  defaultItem!: string;

  @Watch('value')
  clearItem(newVal:any){
    if(this.value === this.defaultItem){
      this.itemValue = newVal
      this.handleInput
    }
  }
  // data
  private classes: any = {
    "lfs-pd-input-block-requred": this.required,
  };
  private placeholder: string = "";
  itemValue: string = this.value;
  //   methods
  deleteItem(){
    this.itemValue = this.defaultItem
    this.$emit("input", this.itemValue);
  }

  handleInput() {
    this.$emit("input", this.itemValue);
  }
}
